import { Box, Button } from "@mui/material";
import { API_URL, BootstrapTooltip } from "../../utilities";
import PageTitle from "../../components/PageTitle";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
  GridRowId,
  GridToolbarContainer,
} from "@mui/x-data-grid";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import moment from "jalali-moment";
import GridViewMUIX from "../../components/GridViewMUIX";
import { Typography, Tooltip } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/auth";
import { MouseEvent, useEffect, useState } from "react";
import { useNotifications } from "@toolpad/core/useNotifications";
import AddIcon from "@mui/icons-material/Add";

import PopoverComponent from "../../components/PopoverComponent";

import SkeltonProgress from "../../components/SkeltonProgress";
import { IService } from "src/interface/IService";
import NewFollowUpGroup from "./new-followup-group";
import { getRoutes } from "src/utilities/routes";
const FollowUpGroups = () => {
  const notifications = useNotifications();
  const { user } = useAuth();
  const Routes = getRoutes();

  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ["FollowUpGroups"],
    queryFn: () =>
      fetch(Routes.FollowupRoutes, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      }).then((res) => res.json()),
  });
  const [rows, setRows] = useState<any>();
  const [openTask, setOpenTask] = useState<boolean>(false);
  const [editingData, setEditingData] = useState<any>(null);

  useEffect(() => {
    if (error) {
      notifications.show("خطا در دریافت اطلاعات" + error.toString(), {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    }
  }, [error]);

  useEffect(() => {
    data && setRows(data);
  }, [data, user?.token]);

  const [deleteId, setDeleteId] = useState<string>("");

  const { mutateAsync: deleteAsync, isPending: isDeleteLoading } = useMutation({
    mutationFn: async (id: string) => {
      const response = await fetch(Routes.FollowupRoutes + id, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });

  const { data: ServicesData } = useQuery({
    queryKey: ["ServicesData"],
    queryFn: () =>
      fetch(Routes.ServicesRoutes, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      }).then((res) => res.json()),
  });
  const [getServices, setServices] =
    useState<Array<{ label: string; value: number }>>();
  useEffect(() => {
    if (ServicesData) {
      setServices(
        ServicesData.map((item: IService) => ({
          label: item.name,
          value: item.id,
        }))
      );
    }
  }, [ServicesData]);

  const handleEditClick = (id: GridRowId) => () => {
    const rowData = rows.find((row: any) => row.id === id);
    if (rowData) {
      setEditingData(rowData);
      setOpenTask(true);
    }
  };

  const handleDeleteClick = (
    event: MouseEvent<HTMLButtonElement>,
    id: string
  ) => {
    setAnchorDeleteEl(event.currentTarget);
    setDeleteId(id);
  };

  const handleDeletePopoverClose = () => {
    setAnchorDeleteEl(null);
    setDeleteId("");
  };

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      const res = await deleteAsync(deleteId);
      if (res.status) {
        notifications.show("حذف با موفقیت انجام شد!", {
          severity: "success",
          autoHideDuration: 5000,
        });
      } else {
        notifications.show("خطا در حذف!", {
          severity: "error",
          autoHideDuration: 5000,
        });
      }
    } catch (error) {
      console.log("🚀 ~ handleDelete ~ error:", error);
      notifications.show("خطا در حذف!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    } finally {
      refetch();
      handleDeletePopoverClose();
    }
  };

  const handleClose = () => {
    setOpenTask(false);
    setEditingData(null);
  };

  const [anchorDeleteEl, setAnchorDeleteEl] =
    useState<HTMLButtonElement | null>(null);
  const openDeletePopover = Boolean(anchorDeleteEl);
  const idDeletePopover = openDeletePopover ? "simple-popover" : undefined;

  const columns: GridColDef[] = [
    {
      field: "actions",
      type: "actions",
      headerAlign: "center",
      headerName: "عملیات",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      cellClassName: "actions",
      minWidth: 150,
      getActions: (params) => {
        return [
          <BootstrapTooltip title="ویرایش">
            <GridActionsCellItem
              icon={<EditIcon color="primary" />}
              label="ویرایش"
              className="textPrimary"
              onClick={handleEditClick(params.id)}
              color="inherit"
            />
          </BootstrapTooltip>,
          <BootstrapTooltip title="حذف">
            <GridActionsCellItem
              icon={<DeleteIcon color="error" />}
              label="حذف"
              onClick={(event) =>
                handleDeleteClick(event, params.id.toString())
              }
              color="inherit"
            />
          </BootstrapTooltip>,
        ];
      },
    },
    {
      field: "serviceRef",
      headerName: "خدمات",
      align: "left",
      headerAlign: "left",
      editable: false,
      sortable: true,
      minWidth: 150,
      type: "singleSelect",
      valueOptions: getServices,
      renderCell: (params: GridRenderCellParams<any, number>) => {
        const service = getServices?.find((s: any) => s.value === params.value);
        return service?.label || params.value;
      },
    },
    {
      field: "priority",
      headerName: "اولویت",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      type: "number",
      minWidth: 120,
    },
    {
      field: "title",
      headerName: "عنوان",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      minWidth: 200,
    },
    {
      field: "isSendSMS",
      headerName: "پیامک",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      type: "boolean",
      minWidth: 120,
    },
    {
      field: "sampleSMSPayment",
      headerName: "نمونه پیام",
      align: "left",
      headerAlign: "center",
      editable: false,
      sortable: true,
      width: 100,
      flex: 1,
      renderCell: (params: GridRenderCellParams<any, string>) => {
        const fullText = params.value || "";
        // کوتاه کردن متن به 30 کاراکتر اول
        const truncatedText =
          fullText.length > 30 ? fullText.substring(0, 30) + "..." : fullText;

        return (
          <Tooltip
            title={
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  maxWidth: "400px",
                  maxHeight: "300px",
                  overflow: "auto",
                }}
              >
                {fullText || "(خالی)"}
              </Typography>
            }
            arrow
            placement="top"
          >
            <Typography
              variant="body2"
              component="div"
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                //textAlign: "right",
                width: "100%",
                cursor: fullText ? "help" : "default",
              }}
            >
              {truncatedText}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "createdOn",
      headerName: "تاریخ ایجاد",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
      minWidth: 180,
    },
    {
      field: "modifiedOn",
      headerName: "تاریخ ویرایش",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
      minWidth: 180,
    },
  ];

  function EditToolbar() {
    return (
      <GridToolbarContainer>
        <Button
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setOpenTask(true)}
        >
          گروه پیگیری جدید
        </Button>
      </GridToolbarContainer>
    );
  }
  return (
    <>
      <PageTitle title="گروه پیگیری" />
      <PopoverComponent
        caption=" حذف انجام شود؟"
        anchorEl={anchorDeleteEl}
        handlePopoverClose={handleDeletePopoverClose}
        handler={handleDelete}
        id={idDeletePopover}
        isLoading={isDeleteLoading}
        open={openDeletePopover}
        key={"delete"}
      />

      <NewFollowUpGroup
        open={openTask}
        handleClose={handleClose}
        refetch={refetch}
        editingData={editingData}
      />

      <Box
        sx={{
          width: {
            xs: 370, // عرض برای اندازه‌های کوچک
            sm: 500, // عرض برای اندازه‌های متوسط
            md: 720, // عرض برای اندازه‌های بزرگ
            lg: "calc(100% - 80px)", // عرض برای اندازه‌های خیلی بزرگ
            xl: "calc(100% - 80px)", // عرض برای اندازه‌های فوق‌العاده بزرگ
          },
        }}
      >
        {isLoading ? (
          <SkeltonProgress />
        ) : (
          <GridViewMUIX
            columns={columns}
            loading={isLoading}
            EditToolbar={EditToolbar}
            sortFields={{ field: "modifiedOn", sort: "desc" }}
            rows={rows}
            gridUniqueName="FollowUpGroups"
          />
        )}
      </Box>
    </>
  );
};

export default FollowUpGroups;
